<template>
  <div>
    <!-- Hero Section -->
    <div
      class="relative h-[60vh] sm:h-[50vh] xs:h-[40vh] bg-cover bg-center flex flex-col items-center justify-center text-center px-4"
      :style="{ backgroundImage: 'url(https://myi.agency/wp-content/uploads/2025/02/Case_Header_TCS.gif)' }"
    >
      <!-- Overlay sombre -->
      <div class="absolute inset-0 bg-black/60"></div>

      <!-- Contenu texte -->
      <div class="relative z-10">
        <h1
          class="text-transparent bg-clip-text 
                 text-5xl sm:text-6xl md:text-8xl lg:text-[100px] max-w-6xl text-center font-bold 
                 drop-shadow-lg mb-4 opacity-0 
                 animate-fade-in-up animation-delay-500"
          style="
            background: linear-gradient(
              90deg,
              #366B92 0%,
              #FFFFFF 25%,
              #FFFFFF 67%,
              #366B92 100%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          "
        >
         Contact
        </h1>

        <p
          class="text-white text-base sm:text-lg md:text-xl max-w-3xl drop-shadow mb-6 opacity-0 animate-fade-in-up animation-delay-1000"
        >
          Rejoignez la compétition dès aujourd'hui. Événements, tournois, communauté — vivez l'expérience Esport ultime.
        </p>
      </div>
    </div>

    <!-- Form Section -->
    <section class="px-4 sm:px-8 md:px-16 lg:px-24 py-12 sm:py-16">
      <h1 class="text-2xl sm:text-3xl font-bold text-center text-white">CONTACTEZ-NOUS</h1>
      <p class="text-center text-gray-400 mt-2 text-sm sm:text-base">Une question, un partenariat, un projet ? Écrivez-nous.</p>

      <form class="mt-8 sm:mt-12 max-w-4xl mx-auto p-6 sm:p-8 rounded-xl shadow-lg space-y-6 bg-white">
        <!-- Ligne Nom et Email -->
        <div class="flex flex-col md:flex-row gap-4 md:gap-6">
          <div class="flex flex-col w-full md:w-1/2">
            <label class="mb-1 font-semibold text-gray-700">Nom</label>
            <input type="text" placeholder="Votre nom"
                   class="p-3 rounded-lg bg-gray-100 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-400">
          </div>

          <div class="flex flex-col w-full md:w-1/2">
            <label class="mb-1 font-semibold text-gray-700">Email</label>
            <input type="email" placeholder="Votre email"
                   class="p-3 rounded-lg bg-gray-100 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-400">
          </div>
        </div>

        <!-- Ligne Téléphone et Sujet -->
        <div class="flex flex-col md:flex-row gap-4 md:gap-6">
          <div class="flex flex-col w-full md:w-1/2">
            <label class="mb-1 font-semibold text-gray-700">Téléphone</label>
            <input type="tel" placeholder="Numéro de téléphone"
                   class="p-3 rounded-lg bg-gray-100 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-400">
          </div>

          <div class="flex flex-col w-full md:w-1/2">
            <label class="mb-1 font-semibold text-gray-700">Sujet</label>
            <input type="text" placeholder="Sujet de votre message"
                   class="p-3 rounded-lg bg-gray-100 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-400">
          </div>
        </div>

        <!-- Champ Message -->
        <div class="flex flex-col">
          <label class="mb-1 font-semibold text-gray-700">Message</label>
          <textarea rows="5" placeholder="Écrivez votre message ici..."
                    class="p-3 rounded-lg bg-gray-100 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-400"></textarea>
        </div>

        <!-- Bouton d'envoi -->
        <div class="text-center">
          <button type="submit"
                  class="mt-4 px-6 sm:px-8 py-2 sm:py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 transition">
            Envoyer
          </button>
        </div>
      </form>
    </section>
  </div>
</template>





<style scoped>

@keyframes fade-in-up {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  animation: fade-in-up 1s ease-out forwards;
}

.animation-delay-500 {
  animation-delay: 0.5s;
}
.animation-delay-1000 {
  animation-delay: 1s;
}
.animation-delay-1500 {
  animation-delay: 1.5s;
}
</style>